
/**
 * @description 身份證字號或新式統一證號 (第1碼: 字母 , 第2碼: 1、8為男, 2、9為女)
 */
export const IdRegex = /^[A-Z]{1}[1289]{1}[\d]{8}$/;

/**
 * @description Number Only
 */
export const NumberOnlyRegex = /^[\d]*$/;

/**
 * @description 必須包含數字
*/
export const ShouldIncludeNum = /^.*[\d]+.*$/;

/**
 * @description 僅允許英數字
*/
export const NumAndEnglishRegex = /^[A-Za-z\d]*$/;

/**
 * @description 僅允許英數字與 - 符號
*/
export const NumAndEnglishDashRegex = /^[A-Za-z\d~!@#$%^&*()_+-{}=`,./\\;'"<>:|\s]*$/;

/**
 * @description 電話區碼
 */
export const TelAreaRegex = /^(02|03|037|04|049|05|06|07|08|082|0826|0836|089)(.*)$/;

/**
 * @description 手機號碼檢核
 */
export const mobileRegex = /^(09[\d]{8})$/;

/** @description Email 檢核 */
// export const emailRegex = /^([a-zA-Z\d-\\_\\.\\+])+\@(([a-zA-Z0-9-])+)+\.([a-zA-Z0-9]{2,4})+$/;
export const emailRegex = /^[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*$/;
